import { render, staticRenderFns } from "./TelaDeNovidades.vue?vue&type=template&id=2fe134a2&"
import script from "./TelaDeNovidades.vue?vue&type=script&lang=ts&"
export * from "./TelaDeNovidades.vue?vue&type=script&lang=ts&"
import style0 from "./TelaDeNovidades.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VOverlay,VProgressCircular,VRow})
